module.exports = __webpack_public_path__ + "static/media/delete.45ae5a46.svg";